import { graphql } from '@teachino/shared-infrastructure';

export const editTopicGoalsMutation = graphql(`
  mutation EditTopicGoals($id: String!, $goals: String!) {
    updateTopic(updateTopicInput: { id: $id, goals: $goals }) {
      topic {
        __typename
        id
        goals
      }
    }
  }
`);
